import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    headerTitle: translate({ id: 'settings.personalization.view.headerTitle' }),
    headerDescription: translate({ id: 'settings.personalization.view.headerDescription' }),
    save: translate({ id: 'settings.rmAccount.edit.footer.save' }),
    cancel: translate({ id: 'settings.rmAccount.edit.footer.cancel' }),
    weekStartsOn: translate({ id: 'settings.personalization.edit.fields.weekStartsOn.label' }),
  }))

  return api
}
